import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import BlogPost from './pages/BlogPost';
import Navbar from './components/Navbar';
import { BodyTest, Blog, BlogSection, Contact, Footer } from './components';

const Home = () => {
    const [navbarVisible, setNavbarVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setNavbarVisible(window.scrollY > 100);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div>
            {/* Navbar lives here so its z-50 is never trapped inside a sticky stacking context */}
            <nav
                className={`fixed top-0 left-0 w-full z-50 transition-opacity duration-500 ${
                    navbarVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'
                }`}
            >
                <Navbar />
            </nav>

            <LandingPage />

            <div className="relative z-10">
                <BodyTest />
                <Blog />
                <BlogSection />
                <Contact />
                <Footer />
            </div>
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/blog/:id" element={<BlogPost />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
